import { useDrag } from "client/hooks/utils/useDrag";
import { editIconDraggingState, setIconSettings } from "store/features/memeGenerator/actions";
import { MemeGeneratorState } from "store/features/memeGenerator/types";
import { getMeme } from "store/features/memeGenerator/utils/getMeme";
import {
    calculateCenterPosition,
    calculateSPosition,
    convertFixedXToRelativeX,
    convertFixedYToRelativeY,
} from "store/features/memeGenerator/utils/useResizeHandlers";
import { useAppDispatch } from "store/store";

export const useRotateHandler = (icon: NonNullable<MemeGeneratorState["meme"]>["icons"][number]) => {
    const dispatch = useAppDispatch();

    const handleDrag = (clientX: number, clientY: number) => {
        const meme = getMeme();
        const item = {
            left: icon.settings.left,
            top: icon.settings.top,
            width: icon.settings.width,
            height: icon.settings.height,
            rotation: icon.settings.rotation,
        };
        const container = {
            left:
                meme.settings.parentContainerInitial.left +
                meme.settings.image.left +
                meme.settings.itemsContainer.left,
            top: meme.settings.parentContainerInitial.top + meme.settings.image.top + meme.settings.itemsContainer.top,
        };
        const [cX, cY] = calculateCenterPosition(item);
        const [eX, eY] = [convertFixedXToRelativeX(clientX, container), convertFixedYToRelativeY(clientY, container)];
        const [sX, sY] = calculateSPosition(item);
        const [reX, reY] = [eX - cX, cY - eY];
        const [rsX, rsY] = [sX - cX, cY - sY];
        const angleCE = (Math.atan2(reY, reX) * 180) / Math.PI;
        const angleCS = (Math.atan2(rsY, rsX) * 180) / Math.PI;
        const diff = angleCS - angleCE;
        dispatch(
            setIconSettings({
                id: icon.id,
                rotation: item.rotation + diff,
            }),
        );
    };

    function onPointerUp() {
        setTimeout(() => {
            dispatch(
                editIconDraggingState({
                    id: icon.id,
                    draggingState: {
                        rotate: false,
                    },
                }),
            );
        }, 50);
    }

    function onPointerDown() {
        dispatch(
            editIconDraggingState({
                id: icon.id,
                draggingState: {
                    rotate: true,
                },
            }),
        );
    }

    const { dragHandlers, isDragging } = useDrag({ positionType: "fixed", onPointerMove: handleDrag, onPointerUp, onPointerDown });

    return { dragHandlers, isDragging };
};
